module.exports = function _identity(x) { return x; };



/*****************
 ** WEBPACK FOOTER
 ** ./~/ramdasauce/~/ramda/src/internal/_identity.js
 ** module id = 140
 ** module chunks = 0
 **/